module.exports = __webpack_public_path__ + "img/901206058.d00451b8.png";